import { compose } from 'redux'
import { connect } from 'react-redux'


const mapStateToProps = (state, props) => {
    const { DinamicCustomFormsReducer } = state
    const controler = DinamicCustomFormsReducer.rLista;
    let lista = controler.lista;
    let customFormInterno = null;
    lista.forEach(f => {
        if (f.uid === props.item.customFormUid) {
            customFormInterno = f;
        }
    });
    



    return {
        customFormInterno,
    };
};


export default compose(
    connect(mapStateToProps, {}),
);


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/PesquisaItensCustomForm/Tabela/Tabela.enhancer.js